import { computed, Ref } from "@vue/composition-api";
import { VaultFileUsageSubjectTypeEnum } from "@scrile/api-provider/dist/api/VaultsProvider";
import { FilterSubject } from "@/components/VaultController/types";

export const useFilterVaultFiles = (filterSubject?: Ref<FilterSubject | undefined>) => {
  const allowedSubjectsTypesWithZeroId: string[] = [VaultFileUsageSubjectTypeEnum.USER_CONTENT_SETS];

  const subjectIdGuard = computed(() => {
    if (!filterSubject?.value) return false;
    if (filterSubject.value.subjectId !== "0") return true;
    return allowedSubjectsTypesWithZeroId.includes(filterSubject.value.subjectType);
  });

  const fileUsageSubject = computed(() => {
    if (filterSubject?.value && subjectIdGuard.value) return filterSubject.value;
    return undefined;
  });

  return {
    fileUsageSubject,
  };
};
